"use client";

import { Card, Form } from "react-bootstrap";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getToken } from '../../../../utils/auth';

const BasicSuaUser = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { row, mode } = location.state || {};

    const [formData, setFormData] = useState({
        id: row?.id || "",
        username: row?.username || "",
        email: row?.email || "",
        password: "", // Only for add or change
        isdelete: row?.isdelete || false
    });

    useEffect(() => {
        if (mode === "edit" && row) {
            setFormData({
                id: row.id,
                username: row.username,
                email: row.email,
                password: "", // Don't show hash
                isdelete: row.isdelete
            });
        }
    }, [mode, row]);

    // Helper to get Authorization headers
    const getAuthHeaders = () => {
        const token = getToken();
        return token ? {'Authorization': `Bearer ${token}`} : {};
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let url = `${process.env.REACT_APP_API_BASE_URL}/user/add-user`;
        if (mode === "edit") {
            url = `${process.env.REACT_APP_API_BASE_URL}/user/update-user`;
        }
        const payload = {
            id: mode === "edit" ? formData.id : undefined,
            username: formData.username,
            email: formData.email,
            password: formData.password, // Plain password, backend should hash
            isdelete: formData.isdelete
        };
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: { "Content-Type": "application/json", ...getAuthHeaders() },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                alert("User saved successfully!");
                navigate("/tuvien/user");
            } else {
                const error = await response.text();
                alert("Error: " + error);
            }
        } catch (err) {
            alert("Network error: " + err.message);
        }
    };

    return (
        <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4">
                <h4 className="fs-18 mb-4">{mode === "edit" ? "Sửa người dùng" : "Thêm người dùng"}</h4>
                <Form onSubmit={handleSubmit}>
                    {mode === "edit" && (
                        <Form.Group className="mb-4">
                            <label className="label text-secondary">ID</label>
                            <Form.Control type="text" value={formData.id} readOnly className="text-dark h-55" />
                        </Form.Group>
                    )}
                    <Form.Group className="mb-4">
                        <label className="label text-secondary">Username</label>
                        <Form.Control
                            type="text"
                            value={formData.username}
                            onChange={e => setFormData({ ...formData, username: e.target.value })}
                            required
                            className="text-dark h-55"
                        />
                    </Form.Group>
                    <Form.Group className="mb-4">
                        <label className="label text-secondary">Email</label>
                        <Form.Control
                            type="email"
                            value={formData.email}
                            onChange={e => setFormData({ ...formData, email: e.target.value })}
                            required
                            className="text-dark h-55"
                        />
                    </Form.Group>
                    <Form.Group className="mb-4">
                        <label className="label text-secondary">Password</label>
                        <Form.Control
                            type="password"
                            value={formData.password}
                            onChange={e => setFormData({ ...formData, password: e.target.value })}
                            placeholder={mode === "edit" ? "Leave blank to keep current password" : "Enter password"}
                            className="text-dark h-55"
                        />
                    </Form.Group>
                    <Form.Group className="mb-4">
                        <Form.Check
                            type="checkbox"
                            label="Đã xóa"
                            checked={formData.isdelete}
                            onChange={e => setFormData({ ...formData, isdelete: e.target.checked })}
                        />
                    </Form.Group>
                    <div className="d-flex gap-2">
                        <button type="submit" className="btn btn-primary bg-primary bg-opacity-10 text-primary border-0 fw-semibold py-2 px-4">
                            {mode === "edit" ? "Cập nhật" : "Thêm mới"}
                        </button>
                        <button type="button" className="btn btn-danger bg-danger bg-opacity-10 text-danger border-0 fw-semibold py-2 px-4" onClick={() => navigate("/tuvien/user")}>Hủy</button>
                            {mode === "edit" && (
                                <button
                                    type="button"
                                    className="btn btn-warning bg-warning bg-opacity-10 text-warning border-0 fw-semibold py-2 px-4"
                                    onClick={async () => {
                                        // Confirm delete
                                        if (!window.confirm("Bạn có chắc muốn xóa người dùng này?")) return;
                                        // Call update-user API with isdelete = true
                                        const url = `${process.env.REACT_APP_API_BASE_URL}/user/update-user`;
                                        const payload = {
                                            id: formData.id,
                                            username: formData.username,
                                            email: formData.email,
                                            password: formData.password,
                                            isdelete: true
                                        };
                                        try {
                                            const response = await fetch(url, {
                                                method: "POST",
                                                headers: { "Content-Type": "application/json", ...getAuthHeaders() },
                                                body: JSON.stringify(payload)
                                            });
                                            if (response.ok) {
                                                alert("Người dùng đã được xóa!");
                                                navigate("/tuvien/user");
                                            } else {
                                                const error = await response.text();
                                                alert("Error: " + error);
                                            }
                                        } catch (err) {
                                            alert("Network error: " + err.message);
                                        }
                                    }}
                                >
                                    Xóa
                                </button>
                            )}
                    </div>
                </Form>
            </Card.Body>
        </Card>
    );
};

export default BasicSuaUser;
